import React from "react";
import { WynnAutomationCoverSheet } from "./CoverLetterWynnAutomation";
import { ResumeWynnPageOne, ResumeWynnPageTwo } from "./ResumeWynn";

const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const ApplicationWynnAutomation = () => (
    <main data-testid="application-wynn-automation-page" style={{ backgroundColor: "#2a2620", minHeight: "100vh", padding: "40px 16px 80px", fontFamily: SANS }}>
        <div style={{ maxWidth: 794, margin: "0 auto 24px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <div>
                <p style={{ color: "#c9a227", fontSize: 11, letterSpacing: "0.3em", textTransform: "uppercase", margin: 0, fontWeight: 600 }}>
                    Tatva K · Wynn Application Pack · 3 pages
                </p>
                <p style={{ color: "#9a8c70", fontSize: 10, margin: "4px 0 0", letterSpacing: "0.04em" }}>
                    Head of Automation — Entertainment · Wynn Al Marjan Island
                </p>
            </div>
            <a href={`${process.env.REACT_APP_BACKEND_URL}/api/application-wynn-automation/pdf`}
               download="Tatva-K-Wynn-Head-of-Automation.pdf"
               data-testid="application-wynn-automation-download-btn"
               style={{ backgroundColor: "#c9a227", color: "#1a1a1a", padding: "12px 26px", fontSize: 11, letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: 700, borderRadius: 999, textDecoration: "none", display: "inline-block" }}>
                Download PDF
            </a>
        </div>
        <WynnAutomationCoverSheet />
        <ResumeWynnPageOne />
        <ResumeWynnPageTwo />
    </main>
);

export default ApplicationWynnAutomation;
